import { ICountry, ILocation, ILocationContent } from 'interfaces';

export enum LocationActionTypes {
  SET_CURRENT_LOCATION = 'location/setCurrentLocation',
}

export type ILocationState = {
  locations?: ILocationContent;
  currentLocation?: ILocation;
  locationsByCountry?: ILocationContent;
  isFetchingLocation?: boolean;
  countryList?: ICountry[];
};
